<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">The Top Valley Enigma</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-one">Chapter One: Flood</a>
<ol class="toc">
<li id="toc-li-5"><a href="#/text/ch004#flood"></a></li>
</ol>
</li>
<li id="toc-li-6"><a href="#/text/ch005#chapter-two">Chapter Two: Coal</a>
<ol class="toc">
<li id="toc-li-7"><a href="#/text/ch005#coal"></a></li>
</ol>
</li>
<li id="toc-li-8"><span href="#/text/ch006#chapter-three" title="Link target outside of Sample">Chapter Three: Wealth</span>
<ol class="toc">
<li id="toc-li-9"><span href="#/text/ch006#wealth" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-10"><span href="#/text/ch007#chapter-four" title="Link target outside of Sample">Chapter Four: Farm</span>
<ol class="toc">
<li id="toc-li-11"><span href="#/text/ch007#farm" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-12"><span href="#/text/ch008#chapter-five" title="Link target outside of Sample">Chapter Five: Conservationist</span>
<ol class="toc">
<li id="toc-li-13"><span href="#/text/ch008#conservationist" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-14"><span href="#/text/ch009#chapter-six" title="Link target outside of Sample">Chapter Six: Vacation</span>
<ol class="toc">
<li id="toc-li-15"><span href="#/text/ch009#vacation" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-16"><span href="#/text/ch010#chapter-seven" title="Link target outside of Sample">Chapter Seven: Halt</span>
<ol class="toc">
<li id="toc-li-17"><span href="#/text/ch010#halt" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-18"><span href="#/text/ch011#chapter-eight" title="Link target outside of Sample">Chapter Eight: Reef</span>
<ol class="toc">
<li id="toc-li-19"><span href="#/text/ch011#reef" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-20"><span href="#/text/ch012#chapter-nine" title="Link target outside of Sample">Chapter Nine: Ashes</span>
<ol class="toc">
<li id="toc-li-21"><span href="#/text/ch012#ashes" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-22"><span href="#/text/ch013#chapter-ten" title="Link target outside of Sample">Chapter Ten: Bribe</span>
<ol class="toc">
<li id="toc-li-23"><span href="#/text/ch013#bribe" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-24"><span href="#/text/ch014#chapter-eleven" title="Link target outside of Sample">Chapter Eleven: Hire</span>
<ol class="toc">
<li id="toc-li-25"><span href="#/text/ch014#hire" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-26"><span href="#/text/ch015#chapter-twelve" title="Link target outside of Sample">Chapter Twelve: Objectors</span>
<ol class="toc">
<li id="toc-li-27"><span href="#/text/ch015#objectors" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-28"><span href="#/text/ch016#chapter-thirteen" title="Link target outside of Sample">Chapter Thirteen: Threat</span>
<ol class="toc">
<li id="toc-li-29"><span href="#/text/ch016#threat" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-30"><span href="#/text/ch017#chapter-fourteen" title="Link target outside of Sample">Chapter Fourteen: Inspection</span>
<ol class="toc">
<li id="toc-li-31"><span href="#/text/ch017#inspection" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-32"><span href="#/text/ch018#chapter-fifteen" title="Link target outside of Sample">Chapter Fifteen: Lookout</span>
<ol class="toc">
<li id="toc-li-33"><span href="#/text/ch018#lookout" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-34"><span href="#/text/ch019#chapter-sixteen" title="Link target outside of Sample">Chapter Sixteen: Loop</span>
<ol class="toc">
<li id="toc-li-35"><span href="#/text/ch019#loop" title="Link target outside of Sample"></span></li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?cefd8660